import comp from "./TimeSelector";
export default comp;
